import { render, staticRenderFns } from "./PurchaseVatRegimeMultiSelect.vue?vue&type=template&id=07524c74&scoped=true"
import script from "./PurchaseVatRegimeMultiSelect.vue?vue&type=script&lang=ts"
export * from "./PurchaseVatRegimeMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07524c74",
  null
  
)

export default component.exports